import { userError } from "@/lib/userError";
import React, { useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { LockKeyhole, UserRound } from "lucide-react";
import { AcaiLogo } from "@/components/AcaiLogo";
import { acceptInvitation } from "@/lib/apiClient";

export default function AcceptInvite() {
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [state, setState] = useState("ready");
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setState("submitting");
    try {
      await acceptInvitation({ token, name, password });
      setState("done");
    } catch (requestError) {
      setError(userError(requestError, "Kutsun hyväksyminen epäonnistui."));
      setState("ready");
    }
  };

  return (
    <main className="auth-screen">
      <div className="auth-card">
        <AcaiLogo />
        <img className="auth-orb" src="/assets/voice-orb-glass-v1.png" alt="" />
        {state === "done" ? (
          <>
            <div>
              <h1>Käyttäjä on valmis</h1>
              <p>Voit nyt kirjautua omalla sähköpostillasi ja salasanallasi.</p>
            </div>
            <Link className="auth-primary-link" to="/">Siirry kirjautumaan</Link>
          </>
        ) : (
          <>
            <div>
              <h1>Liity yrityksen assistenttiin</h1>
              <p>Luo henkilökohtainen käyttäjä kutsun avulla.</p>
            </div>
            {!token ? <p className="auth-error" role="alert">Kutsulinkistä puuttuu tunniste.</p> : (
              <form onSubmit={submit}>
                <label htmlFor="invite-name">Nimi</label>
                <div className="auth-input-wrap">
                  <UserRound aria-hidden="true" />
                  <input id="invite-name" value={name} onChange={(event) => setName(event.target.value)} minLength={2} maxLength={120} autoComplete="name" required autoFocus />
                </div>
                <label htmlFor="invite-password">Salasana</label>
                <div className="auth-input-wrap">
                  <LockKeyhole aria-hidden="true" />
                  <input id="invite-password" type="password" value={password} onChange={(event) => setPassword(event.target.value)} minLength={12} maxLength={128} autoComplete="new-password" required />
                </div>
                <small>Vähintään 12 merkkiä.</small>
                {error && <p className="auth-error" role="alert">{error}</p>}
                <button type="submit" disabled={state === "submitting" || name.trim().length < 2 || password.length < 12}>
                  {state === "submitting" ? "Luodaan käyttäjää…" : "Hyväksy kutsu"}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </main>
  );
}
